import { success as successNotif, error as errorNotif } from "react-notification-system-redux";

import { customerService } from "_services";
import { requiredActionsTypes } from "../types";

export const requiredActionsActions = {
  getRequiredActions,
  resolveRequiredAction,
};

function getRequiredActions() {
  return (dispatch) => {
    dispatch(request());

    customerService.getRequiredActions().then(
      (requiredActions) => dispatch(success(requiredActions)),
      (error) => {
        if (!error.isResponse) {
          customerService.crmGetRequiredActions().then(
            (requiredActions) => dispatch(success(requiredActions)),
            (error) => dispatch(failure(error.toString()))
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: requiredActionsTypes.GET_REQUIRED_ACTIONS_REQUEST };
  }

  function success(payload) {
    return { type: requiredActionsTypes.GET_REQUIRED_ACTIONS_SUCCESS, payload };
  }

  function failure() {
    return { type: requiredActionsTypes.GET_REQUIRED_ACTIONS_FAILURE };
  }
}

function resolveRequiredAction(actionId) {
  return (dispatch) => {
    dispatch(request());

    customerService.resolveRequiredAction(actionId).then(
      () => {
        dispatch(successNotif({ title: "Success", message: "Action resolved." }));
        dispatch(getRequiredActions());
        dispatch(success());
      },
      (error) => {
        if (!error.isResponse) {
          customerService.crmResolveRequiredAction(actionId).then(
            () => {
              dispatch(successNotif({ title: "Success", message: "Action resolved." }));
              dispatch(getRequiredActions());
              dispatch(success());
            },
            (error) => {
              dispatch(
                errorNotif({
                  title: "Error",
                  message: "Something went wrong. Your request has not been executed. Try again.",
                })
              );
              dispatch(failure(error.toString()));
            }
          );
        } else {
          dispatch(
            errorNotif({
              title: "Error",
              message: "Something went wrong. Your request has not been executed. Try again.",
            })
          );
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: requiredActionsTypes.RESOLVE_REQUIRED_ACTION_REQUEST };
  }

  function success() {
    return { type: requiredActionsTypes.RESOLVE_REQUIRED_ACTION_SUCCESS };
  }

  function failure() {
    return { type: requiredActionsTypes.RESOLVE_REQUIRED_ACTION_FAILURE };
  }
}
